import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Тепловоз ТЭ1 20 165';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Серия ТЭ1 №20-165</p>
                    <p>Построен в 1947 году на Харьковском тепловозостроительном заводе</p>
                    <p>Тип - грузо-пассажирский</p>
                    <p>Конструктивная скорость - 93 км.ч</p>
                    <p>Служебный вес - 123,9т</p>
                    <p>Нагрузка на ось - 20,65т</p>
                    <p>Мощность - 1000 л.с.</p>
                </div>
                <div className="pageitem">
                    <p className="sub">Семейство ТЭ1</p>
                    <p>Почти точная копия тепловоза ДА, выполненная по личному указанию Сталина с целью восстановления тепловозостроения в СССР. Локомотив совершенно не годился для поездной работы и его роль заключалась скорее в восстановлении опыта эксплуатации тепловозов. По мере появления более совершенных локомотивов ТЭ1 переводились на маневровую работу.</p>
                    <ul>
                        <li>годы выпуска 1947-1950</li>
                        <li>построено 298</li>
                        <li>списание: в основном, в 1980-х</li>
                        <li>изготовитель - Харьковский завод</li>
                        <li>ведущий инженер - М.Н.Щукин</li>
                        <li>дизель: Д50 (1000 л.с.)</li>
                        <li>вес 123.9 т</li>
                        <li>нагрузка на ось 20.7 т</li>
                        <li>скорость 93 км/ч </li>
                    </ul>
                    <p></p>
                </div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt050.jpg')} /></div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt051.jpg')} /></div>
            </div>
        </>
    );
}